import { Col, Row, Table, Typography, message } from "antd";
import moment from "moment";
import React, { useState } from "react";
import lodash from "lodash";
import { useDispatch } from "react-redux";
import {
  lockJobById,
  updateJobById,
} from "../../../../../store/job/job.action";
// import DialogIncomeInput from "../../dialog/dialog_income_input";

const { Text } = Typography;
const IncomeStaffWaitingTable = (props) => {
  // -------------------------- VAR --------------------------
  const { jobList, userList, setOpenInput, setRecord, userId } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- FUNCTION --------------------------
  const handleClick = (record) => {
    const id = record?.id;
    dispatch(
      lockJobById({ id }, (res) => {
        if (res.status === 200) {
          console.log("locked");
          setOpenInput(true);
          setRecord(record);
        } else {
          message.warning(
            "Someone is entering income for this job. Please choose again later."
          );
        }
      })
    );
    // }
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  const columns = [
    {
      key: "date",
      title: "Job ID",
      align: "center",
      render: (_, record) => getDate(record),
      width: "20%",
    },
    {
      key: "services",
      title: "Services",
      align: "center",
      render: (_, record) => renderServices(record),
      width: "30%",
    },
    {
      title: "Remaining/Total",
      dataIndex: "subtotal",
      key: "subtotal",
      align: "center",
      width: "20%",
      render: (value, record) => renderTotal(record),
    },
    {
      title: "Staff",
      key: "mobile",
      align: "center",
      width: "30%",
      render: (_, record) => renderStaff(record),
    },
  ];

  const getDate = (record) => {
    const text = `${record?.name || "JobName"}`;
    return (
      <Row>
        <Text>{text}</Text>
      </Row>
    );
  };

  const renderServices = (record) => {
    const services = record?.services || [];
    const extraServices = record?.extraServices || [];
    const allServices = [...services, ...extraServices];
    return allServices?.map((service, index) => {
      const name =
        service.name.length > 20
          ? `${index + 1}. ${lodash.slice(service.name, 0, 20).join("")}...`
          : `${index + 1}. ${service.name}`;
      return (
        <Col span={24} key={index} align="left">
          <Row gutter={[5, 5]} justify="space-between">
            <Col>
              <Text>{name}</Text>
            </Col>
            <Col align="right">
              <Text>{`$${service?.price}`}</Text>
              <Text code>x{service?.quantity}</Text>
            </Col>
          </Row>
        </Col>
      );
    });
  };

  const renderStaff = (record) => {
    const staffs = record?.staffs || [];
    return staffs.map((staff, index) => {
      const [staffInfo] =
        userList?.filter((user) => user?.id === staff?.userId) || [];
      const staffName = staffInfo
        ? `${staffInfo?.firstName} ${staffInfo?.lastName}`
        : "No name";
      return (
        <Col span={24} key={index}>
          <Row gutter={[5, 5]} justify="space-between">
            <Col>
              <Text>{`${index + 1}. ${staffName}`}</Text>
            </Col>
            <Col align="right">
              <Text>{`$${staff?.value}`}</Text>
            </Col>
          </Row>
        </Col>
      );
    });
  };

  const renderTotal = (record) => {
    const subTotal = record?.subtotal;
    const spent = lodash.sumBy(record?.staffs, (staff) => staff?.value);
    const remainingValue = subTotal - spent;
    return (
      <>
        <Col span={24}>
          <Row gutter={[5, 5]} justify="space-between">
            <Col>
              <Text>Total:</Text>
            </Col>
            <Col align="right">${subTotal}</Col>
          </Row>
          <Row gutter={[5, 5]} justify="space-between">
            <Col>
              <Text>Remaining:</Text>
            </Col>
            <Col align="right">${remainingValue}</Col>
          </Row>
        </Col>
      </>
    );
  };

  // -------------------------- MAIN --------------------------
  const sortedData = lodash.sortBy(jobList, ["bookingAt"]).reverse();
  const filtedDate = sortedData?.filter((item) => {
    const staffs = item?.staffs;
    const included = staffs?.some((staff) => staff?.userId === userId);
    return !included;
  });
  return (
    <>
      <Table
        bordered
        className="service-table"
        columns={columns}
        dataSource={filtedDate}
        pagination={{
          // responsive : true,
          pageSize: 4,
        }}
        onRow={(record) => ({ onClick: () => handleClick(record) })}
      />
    </>
  );
};
export default IncomeStaffWaitingTable;
